import { render } from "./AppTitleBar.vue?vue&type=template&id=c24ffbf8"
import script from "./AppTitleBar.vue?vue&type=script&lang=js"
export * from "./AppTitleBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__